import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const goodCryptoX: ProjectContentData = {
  id: 'good-crypto-x',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'eth-and-bsc',
          value: 'ETH & BSC',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: '$good',
          value: '$GOOD',
          name: 'Token Ticker',
          description: <span>Symbol of Token.</span>,
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: (
            <>
              <span>21,627,777</span>
              <span className="text-xs">&nbsp;(not including LP)</span>
            </>
          ),
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating supply at the
              <br />
              Token Generation Event (TGE).
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: (
            <>
              <span>$540,694</span>
              <span className="text-xs">&nbsp;(not including LP)</span>
            </>
          ),
          name: 'Initial Market Cap',
          description: (
            <span>
              Shows the initial market cap at the
              <br />
              TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$75,000',
          description: (
            <span>
              Total funds targeted to be
              <br />
              raised across all pools in this Token Sale.
            </span>
          ),
        },
        {
          id: 'presale-price',
          name: 'Presale Price',
          value: '$0.0225',
          description: (
            <span>
              Price per token
              <br />
              during the Sale.
            </span>
          ),
        },
        {
          id: 'up-to-25k',
          name: 'Deposit Size',
          value: '$1-$25,000',
          description: (
            <span>
              In the FCFS Round, the maximum
              <br />
              deposit is capped at $1,000, while in
              <br />
              the Pro-Rata Round, it is set at
              <br />
              $25,000.
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for Token Sale participation.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'tge',
          value: '17.5% on TGE',
          name: 'At TGE',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable/distributed at the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '1 month cliff',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '10-month vesting',
          name: 'Linear Vesting',
          description: (
            <span>
              Token distribution schedule post-.
              <br />
              cliff period.
            </span>
          ),
        },
        {
          id: 'distribution method',
          value: 'goodcryptoX Team',
          name: 'Distribution Method',
          description: (
            <span>
              In this token sale, the project will
              <br />
              handle the distribution of tokens.
            </span>
          ),
        },
      ],
    },
    {
      id: 'presale-schedule',
      label: 'Presale Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sale-start',
          value: '20.08',
          name: 'Sale Start',
          description: <span>Start date of the Token Sale.</span>,
        },
        {
          id: 'sale-end',
          value: '23.08',
          name: 'Sale End',
          description: <span>End date of the Token Sale.</span>,
        },
        {
          id: 'pre-market-trading-start',
          name: 'Premarket Trading Start',
          value: '26.08',
          description: (
            <span>
              Starting date of the Pre-Market OTC
              <br />
              Trading
            </span>
          ),
        },
      ],
    },
  ],
};
